module.exports = __webpack_public_path__ + "media/images/menu/scutum-5982faf3eaec24ac95909c941d7abafd.jpg";